import { IAppEntity } from "../../entities";
import React from "react";
import { CreateVehicleDto } from "../../../dtos/catalogs/vehicle/CreateVehicleDto";
import { VehicleService } from "../../../services/catalogs/VehicleService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupVehicle } from "../../../components/Shared/NewForms/NFLookupVehicle";
import {VehicleDetail} from "../../../components/Pages/Catalogs/Vehicle/VehicleDetail";
import VehicleList from "../../../components/Pages/Catalogs/Vehicle/VehicleList";

export const Vehicle: IAppEntity = {
  entityType: "catalog",
  title: "Vehicle",
  pluralTitle: "Vehicle",
  apiUrl: "Vehicles",
  apiEnum: ReferenceTypes.CatalogVehicle,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(VehicleDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VehicleList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVehicle, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new VehicleService(this.apiUrl);
  },
  getEmptyModel(): CreateVehicleDto {
    return {
      name: "",
      vehiclePlateNumber: "",
      createdDate: new Date(),
    };
  },
};
